/**
 * Shared layout numbers for the compare column system — the desktop page, the
 * mobile screen and the card overlays all measure against these.
 */

/**
 * Desktop: fixed per-column width so the comparison hugs the left of the
 * content rail and every section shares the exact same column axis regardless
 * of player count.
 */
export const COLUMN_WIDTH = 280;

/**
 * Mobile: every player column has this minimum width; below it the comparison
 * scrolls horizontally instead of squishing (Android reference viewport is
 * 360px, so two columns always fit and a third only joins inline from ~510px
 * up).
 */
export const MIN_COLUMN_WIDTH = 170;

/** PlayerCardView's unscaled size — cards scale down to sit inside a column. */
export const CARD_BASE_WIDTH = 180;

/** The card art's unscaled height — overlays anchor to its bottom edge. */
export const CARD_BASE_HEIGHT = 250;

/** MetaRatingChip's height (h-7.5). */
export const CHIP_HEIGHT = 30;

/** Mobile: breathing room a scaled card keeps inside its column. */
export const CARD_COLUMN_GUTTER = 8;

/** Grid template for `count` fixed-width compare columns. */
export const columnGridStyle = (
  count: number,
  width: number,
): React.CSSProperties => ({
  gridTemplateColumns: `repeat(${count}, ${width}px)`,
});
